import {useEffect, useRef} from 'react';
import {makeAutoObservable, onBecomeObserved, runInAction} from 'mobx';
import {makeLoggable} from 'mobx-log';

import apiService from '../transport/apiService';

export type LinesParams = Parameters<typeof apiService.searchLines>[0];

/**
 * General purpose store for lines. Not in mobx state tree
 */
export class LinesStore {
  lines: any[] = [];
  isLoading: boolean = false;

  private params: LinesParams;

  constructor(params: LinesParams) {
    this.params = params;

    makeAutoObservable(this);
    makeLoggable(this);
    onBecomeObserved(this, 'lines', this.load);
  }

  private load = async () => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const lines = await apiService.searchLines(this.params);
      runInAction(() => {
        this.lines = lines;
      });
    } catch (e) {
      console.log(e);
    }
    runInAction(() => {
      this.isLoading = false;
    });
  };
}
